import { getCookie } from '@/helpers/cookies.js'
// COOKIE
export default function initMaintenanceWatcher (store, httpInstance) {
  // guarda último valor para evitar commits redundantes
  let _lastMaintenanceVal = null

  // Lee la cookie 'maintenance' y commitea solo si hay cambio
  function commitFromCookie () {
    try {
      const c = getCookie('maintenance')
      const val = c !== null && (c === 'true' || c === '1')
    
      if (_lastMaintenanceVal === val) return // nada que hacer

      _lastMaintenanceVal = val

      if (store && typeof store.hasModule === 'function') {
        if (store.hasModule('maintenance')) {
          store.commit('maintenance/SET_MAINTENANCE', val)
        }
      } else {
        try { store.commit('maintenance/SET_MAINTENANCE', val) } catch (e) { /* ignore */ }
      }
    } catch (e) { /* ignore errors */ }
  }

  // Inicializa con el valor actual de la cookie
  commitFromCookie()

  // Cabeceras de go-arpa con el estado de la compañía: la cookie es del dominio de la API y,
  // con el front en otro dominio (PRE/PROD), no se puede leer. Sin cabeceras, se usa la cookie.
  let _lastSegEleviaOff = null
  function commitFromHeaders (headers) {
    const maintenance = headers && headers['x-arpa-maintenance']
    const segElevia = headers && headers['x-arpa-segelevia']
    if (segElevia !== undefined && (segElevia === 'off') !== _lastSegEleviaOff) {
      _lastSegEleviaOff = segElevia === 'off'
      try { store.commit('maintenance/SET_SEGELEVIA_OFF', _lastSegEleviaOff) } catch (e) { /* ignore */ }
    }
    if (maintenance === undefined) return false
    const val = maintenance === 'true'
    if (_lastMaintenanceVal !== val) {
      _lastMaintenanceVal = val
      try { store.commit('maintenance/SET_MAINTENANCE', val) } catch (e) { /* ignore */ }
    }
    return true
  }

  // axios-like interceptor: tras cada respuesta/error lee las cabeceras (o la cookie)
  if (httpInstance && httpInstance.interceptors && httpInstance.interceptors.response) {
    httpInstance.interceptors.response.use(response => {
      if (!commitFromHeaders(response && response.headers)) commitFromCookie()
      return response
    }, error => {
      if (!commitFromHeaders(error && error.response && error.response.headers)) commitFromCookie()
      return Promise.reject(error)
    })
  }

  // Wrap fetch: tras cada fetch lee la cookie
  if (typeof window !== 'undefined' && window.fetch) {

    const origFetch = window.fetch.bind(window)
    window.fetch = async (...args) => {
      const resp = await origFetch(...args)
      try { commitFromCookie() } catch (e) { /* ignore */ }
      return resp
    }
  }

  // Wrap XMLHttpRequest: tras cada llamada XHR lee la cookie
  if (typeof window !== 'undefined' && window.XMLHttpRequest) {

    const OrigXHR = window.XMLHttpRequest
    const proto = OrigXHR.prototype
    const origOpen = proto.open
    const origSend = proto.send

    proto.open = function () {
      this._method = arguments[0]
      this._url = arguments[1]
      return origOpen.apply(this, arguments)
    }

    proto.send = function () {
      this.addEventListener('loadend', () => {
        try { commitFromCookie() } catch (e) { /* ignore */ }
      })
      return origSend.apply(this, arguments)
    }
  }
}